export default __webpack_public_path__ + "static/media/1.bb3e4403.svg";